var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgAdFeedbackError = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("rect", {
    width: 54.5,
    height: 72.5,
    x: 20.75,
    y: 11.75,
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 3.25
  }), React.createElement("rect", {
    width: 8,
    height: 1.5,
    x: 57,
    y: 63.2,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 8.5,
    height: 1.5,
    x: 29,
    y: 56.7,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 24,
    height: 1.5,
    x: 29,
    y: 50.2,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 8,
    height: 1.5,
    x: 57,
    y: 50.2,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 24,
    height: 1.5,
    x: 41,
    y: 56.7,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 24,
    height: 1.5,
    x: 29,
    y: 63.2,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("path", {
    fill: color,
    d: "M29 73.45a2.75 2.75 0 0 1 2.75-2.75h14.5a2.75 2.75 0 1 1 0 5.5h-14.5A2.75 2.75 0 0 1 29 73.45Z"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M42.6 35.46a6.3 6.3 0 1 0-12.6 0 6.3 6.3 0 0 0 12.6 0Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m45.95 35.45 10.226-8.493"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M65.91 35.462a6.3 6.3 0 1 0-12.6 0 6.3 6.3 0 0 0 12.6 0Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M59.611 35.46c-5.835-9.875-.208-17.037-6.942-15.242"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M56.464 24.934h-12.6l-7.56 10.529 9.466.149M45.95 35.45l-2.648-13.231M41.45 22.174h4.04"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M70.5 89C78.508 89 85 82.508 85 74.5S78.508 60 70.5 60 56 66.492 56 74.5 62.492 89 70.5 89Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M65.458 69.445a1.25 1.25 0 0 1 1.799 0l7.915 8.12a1.33 1.33 0 0 1 0 1.846 1.25 1.25 0 0 1-1.799 0l-7.915-8.12a1.33 1.33 0 0 1 0-1.846Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M65.819 79.412a1.33 1.33 0 0 1 0-1.846l7.915-8.12a1.25 1.25 0 0 1 1.799 0 1.33 1.33 0 0 1 0 1.845l-7.915 8.12a1.25 1.25 0 0 1-1.8 0Z",
    clipRule: "evenodd"
  }));
};
export default SvgAdFeedbackError;